<!-- Main navbar -->
<div *ngIf="showToolbar == true" class="navbar navbar-inverse navbar-fixed-top" id="navbar-first" style="z-index: 1000">
    <div class="navbar-header">
        <a class="navbar-brand" [routerLink]="['/docs']"><img src="{{logo}}" alt=""></a>

        <span class="overflow">
          <h4>
            <span>{{ currentState.title }}</span>&nbsp;
            <span *ngIf="currentState?.value == 'DRAFT'" class="label label-default" translate>DRAFT</span>
            <span *ngIf="currentState?.value == 'IN_PROGRESS'" class="label label-warning" translate>IN_PROGRESS</span>
            <span *ngIf="currentState?.value == 'REJECTED'" class="label label-danger" translate>REJECTED</span>
            <span *ngIf="currentState?.value == 'COMPLETED'" class="label label-success" translate>COMPLETED</span>
          </h4>
        </span>

      <ul class="nav navbar-nav visible-xs-block">
        <li><a data-toggle="collapse" data-target="#navbar-mobile"><i class="icon-user"></i></a></li>
      </ul>
    </div>

    <div class="navbar-collapse collapse" id="navbar-mobile">
        <ul class="nav navbar-nav navbar-right">
            <button type="button" class="btn btn-default btn-sm legitRipple" (click)="navigateToHome()" *ngIf="!authorization.authenticated()" translate>Login</button>
            <li *ngIf="authorization.authenticated()" class="dropdown dropdown-user">
                <a id="user-menu" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="icon-user"></i>
                    <span>{{authorization?.userProfile?.user_metadata?.name || authorization?.userProfile?.email}}</span>
                    <i class="caret"></i>
                </a>

                <ul class="dropdown-menu dropdown-menu-right">
                    <li><a [attr.href]="null" (click)="navigateToAccountSettings()"><i class="icon-cog5"></i>{{'My Account' | translate}}</a></li>
                    <li class="divider"></li>
                    <!--<li><a href="#"><span class="badge badge-warning pull-right">58</span> <i class="icon-comment-discussion"></i> Messages</a></li>-->
                    <li><a href="https://destek.imzayeri.com" target="_blank"><i class="icon-aid-kit"></i>{{'Support' | translate}}</a></li>
                    <li><a [attr.href]="null" (click)="showAbout()" data-toggle="modal" data-target="#about-application"><i class="icon-office"></i>{{'About' | translate}}</a></li>
                    <li *ngIf="authorization.authenticated()"><a (click)="authorization.logout()"><i class="icon-switch2"></i>{{'Logout' | translate}}</a></li>
                </ul>
            </li>
        </ul>
    </div>
</div>
<!-- /main navbar -->

<div *ngIf="showAboutModal">
  <sd-about></sd-about>
</div>
